import { lazy, Suspense, useCallback, useEffect, useState } from "react";

import estilos from "./mesa.module.css";

const CaixaChat = lazy(() => import("./CaixaChat"));

/** Signals when the real box mounts (Suspense only mounts a subtree that already loaded). */
function Mounted(props: { onMount: () => void }) {
  const { onMount } = props;
  useEffect(onMount, [onMount]);
  return null;
}

/**
 * A caixa de chat presa embaixo do card, sob demanda: até a pessoa tocar nela (ou usar ⌘K ou
 * "/"), fica uma imitação leve, e a caixa de verdade (com o seletor de modelos e o catálogo)
 * não pesa na primeira carga do card (ADR 0010).
 * The stand-in is already a text field: what the person types while the real box loads is
 * handed to it, without losing a keystroke.
 */
export function Doca(props: { rodando?: boolean; aoParar?: (() => void) | undefined }) {
  const [ativa, setAtiva] = useState(false);
  const [draft, setDraft] = useState("");
  const [loaded, setLoaded] = useState(false);
  const onMount = useCallback(() => {
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (ativa) return;
    const teclar = (e: KeyboardEvent) => {
      const alvo = e.target as HTMLElement | null;
      const digitando = alvo?.closest("input, textarea, select, [contenteditable]");
      if ((e.key === "k" && (e.metaKey || e.ctrlKey)) || (e.key === "/" && !digitando)) {
        e.preventDefault();
        setAtiva(true);
      }
    };
    window.addEventListener("keydown", teclar);
    return () => {
      window.removeEventListener("keydown", teclar);
    };
  }, [ativa]);

  const imitacao = (
    <div className={estilos.caixaLeve}>
      <textarea
        rows={1}
        className={estilos.caixaLeveTexto}
        aria-label="Mande outra mensagem para analisar"
        placeholder={
          props.rodando
            ? "Checando… mande outra mensagem quando quiser"
            : "Mande outra mensagem para analisar…"
        }
        value={draft}
        onFocus={() => {
          setAtiva(true);
        }}
        onChange={(e) => {
          setDraft(e.target.value);
        }}
      />
      {props.rodando ? (
        <button
          type="button"
          className={estilos.caixaLeveParar}
          title="A análise continua no servidor e fica no histórico."
          onClick={props.aoParar}
        >
          <span aria-hidden="true">■</span>
          <span className="visualmente-oculto">Parar de acompanhar esta análise</span>
        </button>
      ) : (
        <span aria-hidden="true" className={estilos.caixaLeveEnviar}>
          ↑
        </span>
      )}
    </div>
  );
  // The stand-in stays in place (with focus and text) until the real box mounts.
  return (
    <>
      {!loaded && imitacao}
      {ativa && (
        <Suspense fallback={null}>
          <CaixaChat
            posicao="baixo"
            rodando={props.rodando}
            aoParar={props.aoParar}
            initialText={draft}
            focar
          />
          <Mounted onMount={onMount} />
        </Suspense>
      )}
    </>
  );
}
